import { useTranslation } from 'react-i18next'
import { Experiment, Variant } from 'react-optimize'
import { EXPERIMENT_ID } from '../utils'

const LocaleText = ({ children }) => {
    const { t, i18n } = useTranslation()
    // Get the current language code and normalize it
    const languageCode = i18n.language.toLowerCase()

    if (
        !languageCode.startsWith('pt') &&
        !languageCode.startsWith('es') &&
        !languageCode.startsWith('ko') &&
        !languageCode.startsWith('hi')
    ) {
        return children
    }

    return (
        <Experiment id={EXPERIMENT_ID} timeout={1000}>
            <Variant id={'0'}>{children}</Variant>
            <Variant id="1">{t(children)}</Variant>
        </Experiment>
    )
}

export default LocaleText
